import type { PremiumReportPlanId } from "@ishvaram/domain-data";
import type { CommerceChannel, CommerceSystem } from "@/lib/commerce-routing";
import type { ReportIntentConfig, ReportIntentSlug } from "@/lib/report-intent-data";
import { REPORT_INTENT_PAGES } from "@/lib/report-intent-data";
import { REPORT_CONTENT } from "@/lib/reports-content";
import {
  ISHVARAM_COMMERCE_SYSTEM,
  ISHVARAM_REPORT_CHECKOUT_CHANNEL,
} from "@/lib/commerce-attribution";

export interface ReportIntentOffer {
  planId: PremiumReportPlanId;
  priceInr: number;
  headline: string;
  subhead: string;
  source: string;
  collectInputsHref: string;
  collectInputsLabel: string;
  collectInputsNote: string;
  analyticsContext: {
    checkoutChannel: CommerceChannel;
    commerceSystem: CommerceSystem;
    intent: string;
    sourcePath: string;
    placement: string;
    customerProblem: string;
    urgency: string;
    confidence: number;
    routeRankScore: number;
    routeRankReason: string;
    rankedOfferOrder: string[];
  };
}

export function reportIntentOffer(slug: ReportIntentSlug): ReportIntentOffer {
  const page = REPORT_INTENT_PAGES[slug];
  const report = REPORT_CONTENT[page.reportSlug];
  return {
    planId: report.plan_id,
    priceInr: report.price_inr,
    headline: page.offerHeadline,
    subhead: page.offerSubhead,
    source: `report-landing:${slug}`,
    collectInputsHref: reportIntentCollectInputsHref(page, report.plan_id),
    collectInputsLabel: page.collectInputsLabel,
    collectInputsNote:
      page.inputSurface === "matching"
        ? "Marriage Report needs both charts first. Checkout opens after Kundali Milan has the required inputs."
        : "Birth details come first. Checkout opens after the chart has the inputs needed for your report.",
    analyticsContext: {
      checkoutChannel: ISHVARAM_REPORT_CHECKOUT_CHANNEL,
      commerceSystem: ISHVARAM_COMMERCE_SYSTEM,
      intent: page.intent,
      sourcePath: `/${page.slug}`,
      placement: "report_landing_primary_offer",
      customerProblem: page.customerProblem,
      urgency: "high",
      confidence: 0.9,
      routeRankScore: 100,
      routeRankReason: `report_landing_${report.plan_id}`,
      rankedOfferOrder: [report.plan_id],
    },
  };
}

export function reportIntentCollectInputsHref(page: ReportIntentConfig, planId: string): string {
  if (page.inputSurface === "matching") {
    const params = new URLSearchParams({
      source: `/${page.slug}`,
      next_report: planId,
    });
    return `/kundli-matching/#${params.toString()}`;
  }
  const params = new URLSearchParams({
    intent: page.intent,
    source: `/${page.slug}`,
    next_report: planId,
  });
  return `/free-kundali/#${params.toString()}`;
}
